import { render } from "./myheader.vue?vue&type=template&id=5c750bca&scoped=true"
import script from "./myheader.vue?vue&type=script&lang=js"
export * from "./myheader.vue?vue&type=script&lang=js"

import "./myheader.vue?vue&type=style&index=0&id=5c750bca&scoped=true&lang=less"

import exportComponent from "D:\\Develop\\项目\\机电集团官网\\custom-website-desk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c750bca"]])

export default __exports__